import React, { useState } from "react";
import Pagination from "../../components/pageProps/shopPage/Pagination";
import ProductBanner from "../../components/pageProps/shopPage/ProductBanner";
import ShopSideNav from "../../components/pageProps/shopPage/ShopSideNav";
import { useSelector } from "react-redux";
const Shop = () => {
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const drawerOpen = useSelector((state) => state.view.drawer);

  return (
    <div className=" mx-auto px-2 md:px-4">
      {/* ================= Products Start here =================== */}
      <div
        className={`w-full h-full flex pb-20 ${drawerOpen ? "md:gap-6" : ""} mt-6`}
      >
        <div
          className={`w-fit ${drawerOpen ? "lgl:w-[25%]" : "w-0"} absolute md:relative h-full`}
        >
          <ShopSideNav />
        </div>
        <div className="w-full  h-full flex flex-col gap-4 ">
          {/* Pass setItemsPerPage to update the state */}
          <ProductBanner itemsPerPageFromBanner={setItemsPerPage} />
          {/* Pass itemsPerPage to Pagination */}
          <Pagination itemsPerPage={itemsPerPage} />
        </div>
      </div>
      {/* ================= Products End here ===================== */}
    </div>
  );
};

export default Shop;
